export const LangList = {
  'es-ES': 'es-ES',
} as const

export type LangValues = keyof typeof LangList

export type Lang = {
  lang: LangValues
}

type ISO = Required<Record<keyof typeof LangList, string>>
export const ISOList: ISO = {
  'es-ES': 'es-ES',
}
